import {
  GET_ASSETINSPECTIONCATEGORY,
  GET_ASSETINSPECTIONCATEGORY_SUCCESS,
  GET_ASSETINSPECTIONCATEGORY_FAIL,
  DELETE_ASSETINSPECTIONCATEGORY,
  DELETE_ASSETINSPECTIONCATEGORY_SUCCESS,
  DELETE_ASSETINSPECTIONCATEGORY_FAIL,
  UPDATE_ASSETINSPECTIONCATEGORY,
  UPDATE_ASSETINSPECTIONCATEGORY_SUCCESS,
  UPDATE_ASSETINSPECTIONCATEGORY_FAIL,
  ADD_NEW_ASSETINSPECTIONCATEGORY,
  ADD_ASSETINSPECTIONCATEGORY_SUCCESS,
  ADD_ASSETINSPECTIONCATEGORY_FAIL,
  ASSETINSPECTIONCATEGORY_LOADING,
  ASSETINSPECTIONCATEGORY_RESET,
  ASSETINSPECTIONCATEGORY_RESET_CREATE
} from "./actionType";

export const resetAssetInspectionCategoryState = (actionType) => ({
  type: ASSETINSPECTIONCATEGORY_RESET,
  payload: { actionType },
});


export const resetAssetInspectionCategoryCreateState = (actionType) => ({
  type: ASSETINSPECTIONCATEGORY_RESET_CREATE,
  payload: { actionType }
});

export const getAssetInspectionCategorySuccess = (actionType, data) => ({
  type: GET_ASSETINSPECTIONCATEGORY_SUCCESS,
  payload: { actionType, data },
});

export const getAssetInspectionCategoryFail = (actionType, error) => ({
  type: GET_ASSETINSPECTIONCATEGORY_FAIL,
  payload: { actionType, error },
});

export const getAssetInspectionCategory = data => ({
  type: GET_ASSETINSPECTIONCATEGORY,
  payload: data,
});

export const getAssetInspectionCategoryLoading = () => ({
  type: ASSETINSPECTIONCATEGORY_LOADING
});

export const deleteAssetInspectionCategory = data => ({
  type: DELETE_ASSETINSPECTIONCATEGORY,
  payload: data,
});

export const deleteAssetInspectionCategorySuccess = data => ({
  type: DELETE_ASSETINSPECTIONCATEGORY_SUCCESS,
  payload: data,
});

export const deleteAssetInspectionCategoryFail = error => ({
  type: DELETE_ASSETINSPECTIONCATEGORY_FAIL,
  payload: error,
});

export const updateAssetInspectionCategory = data => ({
  type: UPDATE_ASSETINSPECTIONCATEGORY,
  payload: data,
});

export const updateAssetInspectionCategoryFail = error => ({
  type: UPDATE_ASSETINSPECTIONCATEGORY_FAIL,
  payload: error,
});

export const updateAssetInspectionCategorySuccess = data => ({
  type: UPDATE_ASSETINSPECTIONCATEGORY_SUCCESS,
  payload: data,
});

export const addNewAssetInspectionCategory = data => ({
  type: ADD_NEW_ASSETINSPECTIONCATEGORY,
  payload: data,
});

export const addAssetInspectionCategorySuccess = data => ({
  type: ADD_ASSETINSPECTIONCATEGORY_SUCCESS,
  payload: data,
});

export const addAssetInspectionCategoryFail = error => ({
  type: ADD_ASSETINSPECTIONCATEGORY_FAIL,
  payload: error,
});